import { useEffect, useState } from 'react';
import { CustonGraphMobile, FullScreenIcon } from '../../Components';
// import FullScreenIcon from '../FullScreenIcon';
import { Container, ContainerAbsolute,  ContainerGraph, LegendContainer, ContainerName, Variablesindicator, VariableLegend, VariableColor, 
    ButtonsContainer, TimeSelector, StyledOption, Headers, ButtonFullScreen, ScaleText } from './styles';
import { NumberInput, Text } from '../styles';
import { useTranslation } from "react-i18next";

const CustonGraphContainerMobile = ({id, Name, hasSP, data, max, min, ChangeTime, color, changeScale}) => {

    const { t } = useTranslation();

    function filterDataByTime(array) {
        return array.map(item => ({
            id: item.id,
            Loading: item.Loading,
            data: item.data.map((entry, index) => {
                entry.x = new Date(entry.x);
                return entry
            }),
        }));
    }
    useEffect(() => {
        setMaximo(max)
        setMinimo(min)
    },[max, min])

    const [maximo, setMaximo] = useState(max)
    const [minimo, setMinimo] = useState(min)
    const [fullScreen, setFullScreen] = useState(false)

    return (
        <ContainerAbsolute id={id} $fullScreen={fullScreen}>
            <Headers>
                <ContainerName>
                    {Name}
                </ContainerName>

                <ButtonFullScreen onClick={()=>setFullScreen(!fullScreen)}>
                    <FullScreenIcon/>
                </ButtonFullScreen>
            </Headers>
            <Container color={color} $fullScreen={fullScreen}>

                <ContainerGraph $fullScreen={fullScreen}>
                    {data.length>0?
                        <CustonGraphMobile data={filterDataByTime(JSON.parse(JSON.stringify(data)))} SP={hasSP? true : false} max={maximo} min={minimo}/>
                    :<></>}
                </ContainerGraph>

                <LegendContainer $fullScreen={fullScreen}>

                    <Variablesindicator $fullScreen={fullScreen}>
                        <VariableLegend>
                            <VariableColor $color={'#4361EE'}/>
                            {t("components.custom-graph.variable-caption.process-variable")}
                        </VariableLegend>

                        {hasSP?
                            <VariableLegend>
                                <VariableColor $color={'#3C9'}/>
                                {t("components.custom-graph.variable-caption.set-point")}
                            </VariableLegend>
                        :<></>}
                    </Variablesindicator>

                    {fullScreen &&
                    <ScaleText>Escala de Tempo:</ScaleText>}

                    <TimeSelector onChange={(e)=>ChangeTime(e.target.value, color)}>
                        <StyledOption value={120}> 2 {t("components.custom-graph.time.hours")} </StyledOption>
                        <StyledOption value={360}> 6 {t("components.custom-graph.time.hours")} </StyledOption>
                        <StyledOption value={720}> 12 {t("components.custom-graph.time.hours")} </StyledOption>
                        <StyledOption value={1440}> 24 {t("components.custom-graph.time.hours")} </StyledOption>
                        <StyledOption value={10080}> 1 {t("components.custom-graph.time.weeks")} </StyledOption>
                        <StyledOption value={20160}> 2 {t("components.custom-graph.time.weeks")} </StyledOption>
                    </TimeSelector>
                    
                    {fullScreen &&
                    <>
                        <ButtonsContainer>
                            <Text>{t("components.labels.maximum")}:</Text>
                            <NumberInput type='number' value={maximo} onChange={(e) => {
                                setMaximo(e.target.value);
                                if(changeScale){changeScale(null, e.target.value)}
                            }}></NumberInput>
                        </ButtonsContainer>

                        <ButtonsContainer>
                            <Text>{t("components.labels.minimum")}:</Text>
                            <NumberInput type='number' value={minimo} onChange={(e) => {
                                setMinimo(e.target.value);
                                if(changeScale){changeScale(e.target.value, null)}
                            }}></NumberInput>
                        </ButtonsContainer>
                    </>}


                </LegendContainer>
            </Container>
        </ContainerAbsolute>
    );
}

export default CustonGraphContainerMobile;